export var RESIZE_OBSERVER_SUPPORTED = !!global.ResizeObserver;